import moment from "jalali-moment";

export const jalaliToUtc = (jdate, isStart = true) => {
  const formattedDate = jdate.year + "/" + jdate.month + "/" + jdate.day;
  const m = moment(formattedDate, "jYYYY/jM/jD").locale("utc");
  return m;
};

export const isBefore = (start, end) => {
  if (start.year > end.year) {
    return false;
  } else if (start.year < end.year) {
    return true;
  } else {
    // start and end is in the same year
    if (start.month > end.month) {
      return false;
    } else if (start.month < end.month) {
      return true;
    } else {
      // start and end is in the same year and month
      if (start.day > end.day) {
        return false;
      } else {
        return true;
      }
    }
  }
};

export const getJsonDate = (utcDate) => {
  const date = utcDate.locale("fa").format("YYYY/MM/DD");
  return {
    year: Number(date.split("/")[0]),
    month: Number(date.split("/")[1]),
    day: Number(date.split("/")[2]),
  };
};

export const createDates = (start, end) => {
  let startDate = start;
  let endDate = end;
  let utcDate = jalaliToUtc(startDate);
  const dates = [];
  while (isBefore(startDate, endDate)) {
    dates.push(utcDate.locale("fa").format("YYYY/MM/DD"));
    utcDate = jalaliToUtc(startDate).add(1, "day");
    startDate = getJsonDate(utcDate);
  }
  return dates;
};

export const getDate = (days, prevOrNext) => {
  let date;
  if (prevOrNext === "Prev") {
    date = moment().add(-Number(days), "day");
  } else {
    date = moment().add(Number(days), "day");
  }
  return getJsonDate(date);
};

export const daysBetweenDates = (firstDate, secondDate) => {
  const start = getJsonDate(firstDate);
  const end = getJsonDate(secondDate);
  if (!isBefore(start, end)) {
    return 0;
  } else {
    let startDate = start;
    let endDate = end;
    let utcDate = jalaliToUtc(startDate);
    let numDays = 0;
    while (isBefore(startDate, endDate)) {
      if (numDays > 2000) {
        return numDays;
      } else {
        utcDate = jalaliToUtc(startDate).add(1, "day");
        startDate = getJsonDate(utcDate);
        numDays = numDays + 1;
      }
    }
    return numDays;
  }
};
export const returnJalali = (date) => {
  return moment(date).locale("fa").format("YYYY/MM/DD");
};
export const renderTimeJalali = (date) => {
  if (date) {
    let jalaliTime = moment(date).locale("fa").format("YYYY-MM-DD_HH:mm:ss");
    let timeArray = jalaliTime.split("_");
    return (
      <>
        <span style={{ whiteSpace: "nowrap" }}>{timeArray[0]}</span>
        <br />
        <span style={{ whiteSpace: "nowrap" }}>{timeArray[1]}</span>
      </>
    );
  } else {
    return "__";
  }
};
export const showDate = (date) => {
  return date.year + "/" + date.month + "/" + date.day;
};
export const todayLatin = moment().locale("en").format("YYYY-M-D");
